import { useContext, useMemo, type FC, type ReactNode } from 'react'
import type { VariantSlug } from 'data/product'
import { ProductsContext } from 'components/ProductsProvider'
import ProductVariantProvider from 'components/ProductVariantProvider'

export const BOTTLE_SLUG = process.env.GATSBY_SHOPIFY_BOTTLE_SLUG

interface Props {
  initialVariant?: VariantSlug
  children: ReactNode
}

export const useBottleProduct = () => {
  const products = useContext(ProductsContext)

  const bottle = useMemo(
    () => products.find((product) => product.slug === BOTTLE_SLUG),
    [products]
  )

  if (!bottle) {
    throw new Error('Expected to find bottle product')
  }

  return bottle
}

const BottleProductVariantProvider: FC<Props> = ({
  initialVariant,
  children,
}) => {
  const bottle = useBottleProduct()

  return (
    <ProductVariantProvider initialVariant={initialVariant} product={bottle}>
      {children}
    </ProductVariantProvider>
  )
}

export default BottleProductVariantProvider
